import { detailsUnavailablesHistoryModel } from "../mappers/models.mapper";

export class unavailablesHistory {
    constructor(unavailablesHistoryObj) {
        this.unavailableId       = unavailablesHistoryObj.TypeNotReadyId;        	
        this.unavailableName	 = unavailablesHistoryObj.Description;      	
        this.frame	             = unavailablesHistoryObj.Frame;     	
        this.count		         = unavailablesHistoryObj.Count;      	
        this.total		         = unavailablesHistoryObj.Total;       	
        this.time	             = unavailablesHistoryObj.Time;
        this.max                 = unavailablesHistoryObj.Max;
        this.detail              = detailsUnavailablesHistoryModel(unavailablesHistoryObj.Detail);
    }
}